var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgSlideArrowLeft = function SvgSlideArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "SlideArrowLeft_svg__st0",
    d: "M14.4 27.7L.6 14.2 14.4.5c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L3.4 14.2l12.4 12.1c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3-.2 0-.5-.1-.7-.3z"
  })));
};
export default SvgSlideArrowLeft;